// paths exempt from redirection
const EXEMPT_PATHS = [
  "/embed",
  "/reset-password",
  "/auth-group",
  "/viewcontent",
  "/group/about",
  "/lead",
  "/dashboard"
];

// Pure function to determine if we need to redirect and where
export function getRedirectPath(pathname, dashboardOnly) {
  const currentPath = pathname;
  const isOnExemptPath = EXEMPT_PATHS.some(path => currentPath.includes(path));

  if (dashboardOnly && !isOnExemptPath) return "/dashboard";
  else return null;
}
